import { render, staticRenderFns } from "./MultiSelect.form-builder.vue?vue&type=template&id=4caaa359&scoped=true&"
import script from "./MultiSelect.form-builder.vue?vue&type=script&lang=js&"
export * from "./MultiSelect.form-builder.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelect.form-builder.vue?vue&type=style&index=0&id=4caaa359&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caaa359",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
